var map = {
	"../pages/account/account.module": [
		299,
		6
	],
	"../pages/aiuto/aiuto.module": [
		301,
		15
	],
	"../pages/cart-modal/cart-modal.module": [
		300,
		1
	],
	"../pages/checkout-modal/checkout-modal.module": [
		302,
		2
	],
	"../pages/consigli/consigli.module": [
		315,
		14
	],
	"../pages/login/login.module": [
		304,
		5
	],
	"../pages/news-post/news-post.module": [
		303,
		13
	],
	"../pages/news/news.module": [
		305,
		12
	],
	"../pages/places/places.module": [
		311,
		11
	],
	"../pages/privacy-modal/privacy-modal.module": [
		306,
		10
	],
	"../pages/shop-geo-map/shop-geo-map.module": [
		309,
		9
	],
	"../pages/shop-geo/shop-geo.module": [
		307,
		4
	],
	"../pages/shop-info-modal/shop-info-modal.module": [
		310,
		8
	],
	"../pages/shop-info-prod-modal/shop-info-prod-modal.module": [
		308,
		3
	],
	"../pages/shop/shop.module": [
		312,
		0
	],
	"../pages/tabs/tabs.module": [
		314,
		16
	],
	"../pages/tool/tool.module": [
		313,
		7
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 152;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 152
// module chunks = 17